import { render } from "./SmallCampaignCard.vue?vue&type=template&id=7611f55c&scoped=true"
import script from "./SmallCampaignCard.vue?vue&type=script&lang=js"
export * from "./SmallCampaignCard.vue?vue&type=script&lang=js"

import "./SmallCampaignCard.vue?vue&type=style&index=0&id=7611f55c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7611f55c"]])

export default __exports__